
<template>
  <!-- 激活卡 -->
  <div class="the-card">
    <div class="card-inner">
      <div class="HealthformBox">
        <form action class="HealtInfoForm">
          <div class="InfoForm_item flex">
            <label for="name" class="commonLabel">
              <i>手机号:</i>
            </label>
            <input type="text" v-model="formData.phone" :maxlength="11" />
          </div>
          
          <div class="InfoForm_item flex">
            <label for="name" class="commonLabel">
              <i>激活码:</i>
            </label>
            <input type="text" v-model="formData.cardNo" />
          </div>

          <div class="InfoForm_item flex">
            <label for="name" class="commonLabel">
              <i>推荐人:</i>
            </label>
            <input v-model="formData.employeeNo" />
          </div>

          <div class="InfoForm_item input-div">
            <input
              type="text"
              name="Verification"
              class="Verification phoneBox_item"
              placeholder="请输入图片中的数字"
              v-model="formData.code"
            />
            <div class="VerificationCodeImg InputImg_item">
              <!-- <img src="../../assets/image/bindAcount/VerificationCode.png" alt /> -->
              <i>验证码:</i>
            </div>
            <div class="VerificationBox">
              <img class="tabImgVerificatio" :src="ImgVerificationSrc" @click="tabImgVerification" />
            </div>
          </div>
        </form>
      </div>

      <div class="bottomBtnBox flex">
        <div class="containerBtn" @click="getKey">
          <button class="nextBtn">激 活</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getApi, postApi } from '../../api/index.js'
import {AppIdName,TokenName,jxAppId} from '../../api/api.js';

export default {
  data() {
    return {
      formData: {
        // ImgVerification: "",
        phone: '',
        cardNo: '',
        code: '',
        employeeNo: ''
      },
      lifeToken: '',
      // 控制点击图片刷新
      num: 0,
      // 控制切换图片
      VerificationFlag: true,
      ImgVerificationSrc:''        
    }
  },
  created: function() {
    let appId = localStorage.getItem(AppIdName);
    this.lifeToken = localStorage.getItem(TokenName+appId || "");	
    this.ImgVerificationSrc='https://zg.lifejiankang.com/api/validate/kaptcha.jpg?userCode='+this.lifeToken
  },
  methods: {
    tabImgVerification() {
      this.formData.code = ''
      let date = new Date().toLocaleString()
      this.ImgVerificationSrc = `https://zg.lifejiankang.com/api/validate/kaptcha.jpg?userCode=${this.lifeToken}&time=${date}`
    },
    getadd(callback) {
      if (!/^1\d{10}$/.test(this.formData.phone)) {
        this.$toast('请输入11位手机号码')
        return false
      } else if (!this.formData.cardNo) {
        this.$toast('请输入激活码')
        return false
      } else if (!this.formData.employeeNo) {
        this.$toast('请输入推荐人编号')
        return false
      } else if (!this.formData.code) {
        this.$toast('请输入验证码')
        return false
      } else {
        callback && callback()
      }
     
    },
    
    getKey() {
      this.getadd(() => {
        postApi({
          url: '/card/activate',
          query: {
            // ...this.formData
            cardNo: this.formData.cardNo,
            code: this.formData.code,
            employeeNo: this.formData.employeeNo,
            phone: this.formData.phone
          }
        }).then(res => {
          if (res.resCode == 0) {
            this.toAccount();
          } else {
            this.tabImgVerification()
            this.$toast(res.resMsg || '操作失败')
            
          }
        })
      })
      
    },
    toAccount(){
      this.$router.push({
        path:"/system/voucher"
      })
    },
  }
}
</script>

<style lang="less" scoped>
.the-card {
  width: 100%;
  height: 100%;

  box-sizing: border-box;
}
.card-inner {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.HealthformBox {
  width: 100%;
  //   .InfoForm {
  //     width: 100%;
  //   }

  .InfoForm_item {
    position: relative;
    .VerificationCodeImg {
      position: absolute;
      top: 0.22rem;
      left: 0.38rem;
      i{
         font-size: 0.3rem;
        color: rgb(51, 51, 51);
        font-size: PingFang-SC-Medium;
      
      }
    }
    .VerificationBox {
      position: absolute;
      top: 0.2rem;
      right: 0;
    }
    input,
    .select-box {
      font-size: 0.3rem;
      //   padding-left: 2rem;
      text-align: right;
      padding-right: 0.33rem;
      width: 60%;
      height: 0.9rem;
      border: 0rem transparent solid;
      line-height: 0.9rem;
    }

    width: 100%;
    background-color: #fff;
    border-bottom: rgb(238, 238, 238) solid 0.02rem;

    .commonLabel {
      padding-left: 0.26rem;
      display: block;
      width: 40%;
      height: 100%;
      // text-align: center;
      line-height: 0.9rem;
      letter-spacing: -0.007rem;
      i {
        font-size: 0.3rem;
        color: rgb(51, 51, 51);
        font-size: PingFang-SC-Medium;
        padding-left: 0.1rem;
      }
    }
  }
}
.bottomBtnBox {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1.22rem;
  background-color: rgb(255, 255, 255);

  .containerBtn {
    width: 4rem;
    height: 0.88rem;
    margin: 0.15rem auto;

    .nextBtn {
      width: 100%;
      height: 100%;
      background-color: rgb(77, 205, 112);
      border: 0px transparent solid;
      border-radius: 0.2rem;
      font-size: 0.3rem;
      color: rgb(255, 255, 255);
    }
  }
}
</style>